export default __webpack_public_path__ + "static/google-play-download-white-80940331c5b0180160736559af2edcb1.svg";